import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { TYPE_LABELS } from '@/types/video';
import { formatViews } from '@/utils/format';

export default function HotRanking() {
  const hot = [...videos].sort((a, b) => b.views - a.views).slice(0, 10);
  const maxViews = hot[0]?.views ?? 1;

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.6fr_1fr] lg:gap-10">
        <div>
          <div className="mb-6">
            <span className="font-label inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
              <span className="h-1 w-1 rounded-full bg-accent-500" />
              人气榜单
            </span>
            <h2 className="font-heading mt-2 text-xl font-bold text-foreground-950 md:text-2xl">热门影片榜单</h2>
            <p className="mt-1.5 text-sm text-foreground-600">根据播放量与收藏量综合排序，看看大家都在看什么</p>
          </div>

          <ol className="divide-y divide-background-200/80 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
            {hot.map((video, index) => (
              <li key={video.id}>
                <Link
                  to={`/detail/${video.id}`}
                  className="group flex items-center gap-3 px-3 py-3 transition-colors hover:bg-background-100 md:gap-4 md:px-4"
                >
                  <span
                    className={`font-heading flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                      index < 3
                        ? 'bg-accent-500 text-primary-950'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-16 md:w-11">
                    <img
                      src={video.cover}
                      alt={`${video.title} 缩略图`}
                      title={`${video.title} - 91视频在线`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {video.title}
                    </h3>
                    <p className="mt-1 truncate text-xs text-foreground-500">
                      {TYPE_LABELS[video.type]} · {video.genres.join(' / ')} · {video.year}
                    </p>
                    <div className="mt-1.5 h-1 w-full max-w-[180px] overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${Math.max(12, (video.views / maxViews) * 100)}%` }}
                      />
                    </div>
                  </div>
                  <div className="hidden shrink-0 text-right sm:block">
                    <p className="font-label text-sm font-bold text-accent-600">{video.rating.toFixed(1)}</p>
                    <p className="font-label mt-1 text-xs text-foreground-500">
                      <i className="ri-play-circle-line mr-1" />
                      {formatViews(video.views)}
                    </p>
                  </div>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:pt-16">
          <div className="rounded-lg border border-primary-200/60 bg-primary-50/60 p-6">
            <h3 className="font-heading text-base font-bold text-primary-900">榜单说明</h3>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700">
              <li className="flex gap-2">
                <i className="ri-line-chart-line mt-0.5 text-primary-500" />
                榜单依据近 7 日播放量与收藏量综合计算，每小时更新一次。
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-500" />
                站内内容均为原创示范数据，仅用于产品功能与界面演示。
              </li>
              <li className="flex gap-2">
                <i className="ri-bookmark-line mt-0.5 text-primary-500" />
                喜欢的内容可加入收藏，收藏记录保存在你的浏览器本地。
              </li>
            </ul>
            <Link
              to="/category/movie"
              className="font-label mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              探索更多热门
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}